__turbopack_context__.v({
  "blobsContainer": "style-module-scss-module__iKhNkW__blobsContainer",
  "brightColors": "style-module-scss-module__iKhNkW__brightColors",
  "container": "style-module-scss-module__iKhNkW__container",
  "greenTheme": "style-module-scss-module__iKhNkW__greenTheme",
  "movingBlob": "style-module-scss-module__iKhNkW__movingBlob",
  "staticBlob": "style-module-scss-module__iKhNkW__staticBlob",
});
